module.exports = __webpack_public_path__ + "static/media/logout.ae4a4731.jpeg";